import Comprobante from '@/models/Comprobante';
import axios from 'axios';
function defaultState() {
	return {
		tableData: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setTableDataComprobantes(state: { tableData: Comprobante[] }, data: Comprobante[] | Comprobante) {
		!Array.isArray(data) ? state.tableData.push(data) : (state.tableData = []);
	},
};
const actions = {
	async putAutorizar({ commit }, params: { codcom: number; codtal: number; numero: number; autoriza: boolean; detalle: string }) {
		const r = await axios
			.get(
				`./api/public/proxy/cgi/etenet_putPendAutoStock?codcom=${params.codcom}&codtal=${params.codtal}&numero=${params.numero}&autoriza=${params.autoriza}&motivo=${params.detalle}`
			)
			.then(response => {
				return response;
			});
		return r;
	},
	async callComprobantesaAutorizar({ commit }, params: { data: object; start: number; limit: number }): Promise<Comprobante[]> {
		if (params.start === 0) commit('setTableDataComprobantes', []);
		const r = await axios
			.get(`./api/public/proxy/cgi/etenet_getPendAutoStock?start=${params.start}&limit=${params.limit}`, params.data)
			.then(response => {
				if (response.data.items) {
					response.data.items.forEach((element: Comprobante) => {
						//TODO: codigo necesario cuando se pase formato a tablas.
						//var dateParts = element.fecha.split('-');
						//element.fecha = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
						commit('setTableDataComprobantes', element);
					});
				}
				return response.data;
			});
		return r;
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
